export default __webpack_public_path__ + "static/media/lakshmi-dr.9da16371.jpg";